import { createPinia } from 'pinia';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { ILeague } from '@/types/general';
import LeagueService from '@/services/league.service';

// export const pinia = createPinia();

export const useLeagueStore = defineStore('league.store', {
  // state: (): IState => ({ ...initialState }),
  getters: {},
  actions: {
    fetch(leagueId) {
      return LeagueService.fetch(leagueId);
    },

    fetchAll(account_id, include_interleague) {
      return LeagueService.fetchAll(account_id, include_interleague);
    },

    create(newLeague: ILeague) {
      return LeagueService.create(newLeague);
    },

    getWaivers(leagueId, language) {
      return LeagueService.getWaivers(leagueId, language);
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLeagueStore, import.meta.hot));
}
